import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import pt from './locales/pt.json';
import en from './locales/en.json';
import es from './locales/es.json';
import { guardarEscolha, idiomaEscolhido, idiomaInicial, IDIOMAS, sinaisDoNavegador } from './idioma';

// O idioma inicial vem de `./idioma` (escolha guardada, ou Brasil pelo fuso e pela lista do navegador).
i18n
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
      es: { translation: es },
    },
    lng: idiomaEscolhido() ?? idiomaInicial(sinaisDoNavegador()),
    fallbackLng: 'pt',
    supportedLngs: [...IDIOMAS],
    interpolation: {
      escapeValue: false,
    },
  });

/** Troca feita pela pessoa no seletor de idioma: é a única que fica lembrada. */
export function escolherIdioma(idioma: string) {
  guardarEscolha(idioma);
  return i18n.changeLanguage(idioma);
}

export default i18n;
